import $ from 'jquery';
import 'slick-carousel';

let group = {};
let $group = {};
let $nav = {};

$('.cascade-nav').on('click', function() {
  $nav = $(this);
  group = $(this).data('cascade-group');
  $group = $(this).parents('.cascade-group');
  const last = $(`.cascade-group-${group}`).length;
  let next = $(this).attr('data-next');
  $('.cascade-pane').removeClass('latest');
  if (next <= last) {
    const $pane = $(`#cascade-${next}.cascade-group-${group}`);
    $pane.addClass('is-active');
    $pane.addClass('latest');

    if ( next == last ) {
      $(this).addClass('completed');
      $(this).closest('.cascade-group').addClass('completed');
    }
    $(this).attr('data-next', ++next);
  } 
});

$('.cascade-reset').on('click', function() {
  const cascades = $(`.cascade-group-${group}`);

  // reset the cascades
  cascades.each(function(index) {
    if (index == 0) {
      $(this).addClass('latest');
    } else {
      $(this).removeClass('latest');
      $(this).removeClass('is-active');
    }
  })
  $group.removeClass('completed');
  $nav.attr('data-next', 2);
  $group.find('.cascade-nav').removeClass('completed');
});